export default "__VITE_ASSET__B1AHFx6s__"